import { useCallback, useMemo } from "react";

type PrefetchIntentHandlers = {
  onFocus: () => void;
  onMouseEnter: () => void;
};

export function usePrefetchOnIntent(prefetch: () => Promise<unknown> | void, enabled = true): PrefetchIntentHandlers {
  const prefetchOnIntent = useCallback(() => {
    if (!enabled) return;
    void prefetch();
  }, [prefetch, enabled]);

  return useMemo(() => ({ onFocus: prefetchOnIntent, onMouseEnter: prefetchOnIntent }), [prefetchOnIntent]);
}
